// extracted by mini-css-extract-plugin
export default {"link":"Skip_link__q5Fru"};